module.exports = __webpack_public_path__ + "static/media/construccion-ico.054affdf.svg";